<template>

    <div class="event"  v-if="drag_element != null" style="
            z-index: 99;
            transition: 0s all;
            display: flex;
          " :style="{
      width: drag_element.width + 'px',
      top: drag_element.top + 'px',
      left: drag_element.left + 'px',
      'background-color': drag_element.color,
    }">
          <div class="event_title">
            <div style="font-weight:bold; font-size:10px">{{ drag_element.contact }}</div>
            {{ drag_element.name }}
          </div>
        </div>

</template>


<script>
import "dayjs/locale/it";
export default {
  name: "grid-drag-element",
  props: ["drag_element"],
  watch: {
  },
  methods: {
  }
};
</script>

<style scoped>
.events-container {
  height: 200px;
  height: 100%;
  position: relative;
}

.event {
  z-index: 1;
  display: inline-block;
  background-color: #673ab7;
  color: #fff;
  position: absolute;
  border-radius: 3px;
  padding: 4px 4px;
  overflow: hidden;
  box-sizing: border-box;
  white-space: nowrap;
  display: flex;
  align-items: center;
  height: 34px;
  cursor: pointer;
  border: 0.5px solid #fff;
  transition: all 0.25s;
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+/Edge */
  user-select: none;
  /* Standard */
}

.event .event_drag {
  min-width: 10px;
}

.event_title {
  flex-grow: 1;
  text-align: start;
  min-width: 0px;
  font-size: 12px;
}

.event:hover {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}

.hide {
  left: -120px!important;
}

.hide_segment{
  --translate-x: 0px!important;
}

.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Old versions of Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}



.by-scroll-container::-webkit-scrollbar-track {
  background-color: #fff;
}

.by-scroll-container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #F5F5F5;
}

.by-scroll-container::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #999;
}
</style>